export const MINI_PDP_LAZY_LOAD_INTERSTITIAL = 'MINI_PDP_LAZY_LOAD_INTERSTITIAL';
export const MINI_PDP_LAZY_LOADED_INTERSTITIAL = 'MINI_PDP_LAZY_LOADED_INTERSTITIAL';
export const MINI_PDP_ON_OPEN = 'MINI_PDP_ON_OPEN';
export const MINI_PDP_ON_CLOSE = 'MINI_PDP_ON_CLOSE';
export const MINI_PDP_ON_MODE_CHANGE = 'MINI_PDP_ON_MODE_CHANGE';
export const MINI_PDP_ASYNC = 'MINI_PDP_ASYNC';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const MINI_PDP_PERSIST_ERROR = 'MINI_PDP_PERSIST_ERROR';
export const MINI_PDP_OPEN_ERROR = 'MINI_PDP_OPEN_ERROR';
export const MINI_PDP_CLOSE_ERROR = 'MINI_PDP_CLOSE_ERROR';
export const MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN = 'MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN';
export const MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE = 'MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE';
export const MINI_PDP_ON_SHOP_THE_IMAGE_OPEN = 'MINI_PDP_ON_SHOP_THE_IMAGE_OPEN';
export const MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE = 'MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE';
export const MINI_PDP_ON_SHOP_THE_LOOK_OPEN = 'MINI_PDP_ON_SHOP_THE_LOOK_OPEN';
export const MINI_PDP_ON_SHOP_THE_LOOK_CLOSE = 'MINI_PDP_ON_SHOP_THE_LOOK_CLOSE';
export const MINI_PDP_ON_SHOP_THE_SET_OPEN = 'MINI_PDP_ON_SHOP_THE_SET_OPEN';
export const MINI_PDP_ON_SHOP_THE_SET_CLOSE = 'MINI_PDP_ON_SHOP_THE_SET_CLOSE';
export const MINI_PDP_ON_STYLED_FOR_YOU_OPEN = 'MINI_PDP_ON_STYLED_FOR_YOU_OPEN';
export const MINI_PDP_ON_STYLED_FOR_YOU_CLOSE = 'MINI_PDP_ON_STYLED_FOR_YOU_CLOSE';
export const MINI_PDP_ATC_FROM_STL = 'MINI_PDP_ATC_FROM_STL';
export const MINI_PDP_ATC_FROM_STS = 'MINI_PDP_ATC_FROM_STS';
export const MINI_PDP_ATC_FROM_DG = 'MINI_PDP_ATC_FROM_DG';
export const MINI_PDP_ATC_FROM_STYLEDFORYOU = 'MINI_PDP_ATC_FROM_STYLEDFORYOU';
export const MINI_PDP_ATC_FROM_SHOP_THE_IMAGE = 'MINI_PDP_ATC_FROM_SHOP_THE_IMAGE';
